import React from 'react';
import { Image } from '../../AbstractElements';
import darklogo from '../../assets/images/logo/favicon.png'
import whitelogo from '../../assets/images/logo/logo-icon-white.svg'


const SidebarIcon = () => {

  return (
    <div className="logo-icon-wrapper">
        <a href="index.html">
          <Image attrImage={{ className: "img-fluid for-light" , src: darklogo, alt: "",style: { width: '40px', height: 'auto' } }} />
          <Image attrImage={{ className: "img-fluid for-dark", src: whitelogo, alt: "",style: { width: '40px', height: 'auto' } }} />
        </a>
    </div>  
  );
};
export default SidebarIcon;